<form [formGroup]="quicksightReportForm">
  <table class="table table-striped">
    <ng-container formArrayName="reports">
      <tbody>
        @for (report of reportMapping; track report; let i = $index) {
          <tr [formGroupName]="i">
            <th class="width-250">{{report.report_name}}</th>
            <td>
              <ui-switch
                [(ngModel)]="report.enabled"
                [disabled]="!editingMapping"
              formControlName="value"></ui-switch>
            </td>
          </tr>
        }
      </tbody>
    </ng-container>
  </table>
</form>
@if (!editingMapping) {
  <div>
    <div class="text-left">
      <button class="btn btn-primary" (click)="editMapping()">Edit</button>
    </div>
  </div>
}
@if (editingMapping) {
  <div class="action-wrap text-left">
    <button type="button" class="btn btn-default" (click)="cancelEditing()">Close</button>
    <button type="button" class="btn btn-primary" [disabled]="!quicksightReportForm.valid" (click)="update()">Update</button>
  </div>
}